module.exports = __webpack_public_path__ + "91f78e762fa7cab1e0b0e6b9ebbdd675.png";